import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import WhatIsTrademarkSection from '../components/WhatIsTrademarkSection';
import BenefitsSection from '../components/BenefitsSection';
import ReadyToSecureCTA from '../components/ReadyToSecureCTA';
import WhyImportantSection from '../components/WhyImportantSection';
import FeatureSection from '../components/FeatureSection';
import WhyChooseUs from '../components/WhyChooseUs';
import StatsSection from '../components/StatsSection';
import TrademarkPricingSection from '../components/TrademarkPricingSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <SEO 
        title="Trademark Registration Services | Global Trademark Filer - Protect Your Brand"
        description="Professional trademark registration with USPTO licensed attorneys. 98% success rate, fast filing, transparent pricing. Secure your brand name and logo today."
        keywords="trademark registration, trademark filing, brand protection, USPTO attorney, trademark search, intellectual property registration"
        canonical="/"
      />
      <Hero />
      <WhatIsTrademarkSection />
      <BenefitsSection />
      <ReadyToSecureCTA />
      <WhyImportantSection />
      <FeatureSection />
      <WhyChooseUs />
      <StatsSection />
      <TrademarkPricingSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default HomePage;
